import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useSnapshot } from 'valtio/react';

import { Button } from '@paid-ui/components/button';

import { signUpManager } from '../../models';
import { OwnerType, SignUpStep } from '../../models/enums';
import { resetBusinessFields } from '../../utils/reset-business-fields';

interface Props {
  disabled?: boolean;
  goToStep?: (step: SignUpStep) => void;
}

export const StepOwnerConfirm: React.FC<Props> = ({ disabled, goToStep }) => {
  const form = useFormContext();
  const { currentStep, invitedBusinessSignUp } = useSnapshot(signUpManager);

  useEffect(() => {
    if (invitedBusinessSignUp) {
      form.setValue('ownerType', OwnerType.BUSINESS);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invitedBusinessSignUp]);

  const handleNext = () => {
    form.setValue('ownerType', OwnerType.INDIVIDUALS);
    resetBusinessFields(form);
    goToStep?.(SignUpStep.USER_DETAILS);
  };

  const handleJoinAsBusiness = () => {
    form.setValue('ownerType', OwnerType.BUSINESS);
    goToStep?.(SignUpStep.BUSINESS_STRUCTURE);
  };

  if (currentStep !== SignUpStep.OWNER_CONFIRM) {
    return null;
  }

  return (
    <div className="space-y-9">
      <div className="space-y-3.5">
        <Button variant="solid" disabled={disabled} className="h-[44px]" onClick={handleNext}>
          Continue as individual
        </Button>
        <Button
          variant="outline"
          disabled={disabled}
          className="h-[44px]"
          onClick={handleJoinAsBusiness}
        >
          Join as a business
        </Button>
      </div>
    </div>
  );
};
